export const requestSparePartsList = "REQUEST_SPARE_PART_LIST";
